import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const customIcons: string[] = ['half_moon'];

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  public loadIcons(): void {
    const iconsPath = 'assets/icons';

    customIcons.forEach((icon) => {
      this.iconRegistry.addSvgIcon(
        `cyan_${icon}_filled`,
        this.sanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/filled/${icon}.svg`)
      );
    });

    customIcons.forEach((icon) => {
      this.iconRegistry.addSvgIcon(
        `cyan_${icon}_outlined`,
        this.sanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/outlined/${icon}.svg`)
      );
    });
  }
}
